import React from "react";
import INELTable from "./Components/INELTable";
import Table from "./Components/Table";


const Results = (props) => {
  const { apiResponse, setApiResponse, activeResultTab } = props;

  return (
    <main className="flex-1 overflow-y-auto px-4 h-618 max-[600px]:px-0  ">
      {activeResultTab === "Eligible" ? (
        <Table
          head="Eligible Products"
          apiResponse={apiResponse}
          setApiResponse={setApiResponse}
          activeResultTaab={activeResultTab}
        />
      ) : (
        <INELTable
          head="Ineligible Products"
          apiResponse={apiResponse}
          setApiResponse={setApiResponse}
          activeResultTab={activeResultTab}
        />
      )}
    </main>
  );
};

export default Results;
